import Colors from 'theme/colors';

export const card: any = {
  backgroundColor: Colors.WHITE,
  borderRadius: 12,
  padding: 16,
  marginBottom: 16,
  boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
};

export const label: any = {
  display: 'block',
  fontSize: 13,
  fontWeight: 700,
  marginBottom: 8,
  color: Colors.TEXT,
};

export const hint: any = {
  fontSize: 13,
  lineHeight: 1.5,
  color: '#555',
  margin: '0 0 12px',
};

export const privacy: any = {
  fontSize: 13,
  lineHeight: 1.5,
  color: '#1b5e20',
  background: '#e8f5e9',
  borderRadius: 8,
  padding: '10px 12px',
  marginBottom: 16,
};

export const warnBox: any = {
  fontSize: 13,
  lineHeight: 1.5,
  color: '#e65100',
  background: '#fff3e0',
  borderRadius: 8,
  padding: '10px 12px',
  marginBottom: 12,
};

export const errorBox: any = {
  fontSize: 13,
  lineHeight: 1.5,
  color: '#b71c1c',
  background: '#ffebee',
  borderRadius: 8,
  padding: '10px 12px',
  marginBottom: 12,
};

export const btnRow: any = {
  display: 'flex',
  flexWrap: 'wrap' as const,
  gap: 8,
  marginBottom: 12,
};

const btnBase: any = {
  border: 'none',
  borderRadius: 8,
  padding: '10px 14px',
  fontSize: 14,
  fontWeight: 700,
  cursor: 'pointer',
};

export const primaryBtn: any = {
  ...btnBase,
  backgroundColor: Colors.MAIN_COLOR,
  color: Colors.WHITE,
};

export const secondaryBtn: any = {
  ...btnBase,
  backgroundColor: '#eceff1',
  color: Colors.TEXT,
};

export const dangerBtn: any = {
  ...btnBase,
  backgroundColor: '#ffebee',
  color: '#c62828',
};

export function formatMb(bytes: number): string {
  return (bytes / (1024 * 1024)).toFixed(1);
}

export function chipStyle(active: boolean): any {
  return {
    ...secondaryBtn,
    backgroundColor: active ? Colors.MAIN_COLOR : '#eceff1',
    color: active ? Colors.WHITE : Colors.TEXT,
  };
}
